import React, { useState } from 'react'
import emailjs from "@emailjs/browser";


const Admission = () => {

    const [name, setName] = useState("");
    const [mobile, setMobile] = useState("");
    const [mail, setmail] = useState("");
    const [massages, setMassages] = useState("");
  
    const nameChange = (e) => {
      const value = e.target.value;
      setName(value);
    };
    const mobileChange = (e) => {
      const value = e.target.value;
      setMobile(value);
    };
    const mailChange = (e) => {
      const value = e.target.value;
      setmail(value);
    };
    const massagesChange = (e) => {
      const value = e.target.value;
      setMassages(value);
    };
  
    const sendEmail = (e) => {
      e.preventDefault();
      emailjs
        .sendForm(
          "service_mapkavx",
          "template_l7uiv6q",
          "#myForm",
          "X5KUzJh_LXeCzDftt"
        )
        .then(
          function (response) {
            console.log("SUCCESS!", response.status, response.text);
            if (response.text === "OK") {
              setName("");
              setMobile("");
              setmail("");
              setMassages("");
            }
          },
          function (error) {
            console.log("FAILED...", error);
          }
        );
    };
    

    return (
        <>

            
        </>
    )
}

export default Admission